<template>
  <ModalDefault modal_id="editTask"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_737')"
                :method="editTask"
                :footer="tasks.task.title && tasks.task.due_date && tasks.task.text && tasks.task.status_key !== null && tasks.task.priority_key !== null"
                icon="bx bx-task mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="row cursor-default px-2 pt-2 pb-3"  style="align-items: center; align-self: center;">
          <div v-if="tasks.task.admin_id !== tasks.task.user_id" class="col-md-12 pb-0">
            <div class="alert alert-info rounded-0"  role="alert">
              <span v-if="tasks.task.admin_id === me.data.id" class="pt-2 px-1">
                {{ getTranslations('expression_738') }} <strong>{{ getUserObject('id', tasks.task.user_id).name }}</strong>
              </span>
              <span v-else class="pt-2 px-1">
                {{ getTranslations('expression_739') }} <strong>{{ getUserObject('id', tasks.task.admin_id).name }}</strong>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_635') }} </label>
            <div v-b-tooltip.bottom
                 :title="tasks.task.admin_id !== tasks.task.user_id && tasks.task.admin_id !== me.data.id ?
                        getTranslations('expression_740') :
                        ''"
                 class="input-group mb-2">
              <input type="text"
                     :disabled="tasks.task.admin_id !== tasks.task.user_id && tasks.task.admin_id !== me.data.id"
                     v-model="tasks.task.title"
                     class="input_forms form-control">
            </div>
          </div>
          <div class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_604') }} </label>
            <div v-b-tooltip.bottom
                 :title="tasks.task.admin_id !== tasks.task.user_id && tasks.task.admin_id !== me.data.id ?
                        getTranslations('expression_740') :
                        ''"
                 class="input-group mb-2">
              <input type="datetime-local"
                     :disabled="tasks.task.admin_id !== tasks.task.user_id && tasks.task.admin_id !== me.data.id"
                     v-model="tasks.task.due_date"
                     class="input_forms form-control pt-25">
            </div>
          </div>
          <div class="col-md-12">
            <label class="mb-0">{{ getTranslations('expression_575') }} </label>
            <div v-b-tooltip.bottom
                 :title="tasks.task.admin_id !== tasks.task.user_id && tasks.task.admin_id !== me.data.id ?
                        getTranslations('expression_740') :
                        ''"
                 class="input-group mb-2">
                <textarea class="input_forms form-control"
                          :disabled="tasks.task.admin_id !== tasks.task.user_id && tasks.task.admin_id !== me.data.id"
                          v-model="tasks.task.text"
                          rows="2" style="resize: none">
                </textarea>
            </div>
          </div>
          <div class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_67') }} </label>
            <div class="input-group mb-2">
              <select v-model="tasks.task.status_key" class="input_forms custom-select">
                <option disabled>{{ getTranslations('expression_741') }}</option>
                <option v-for="status in configs.data.task_statuses"
                        :key="status.id"
                        :value="status.id">
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_638') }} </label>
            <div v-b-tooltip.bottom
                 :title="tasks.task.admin_id !== tasks.task.user_id && tasks.task.admin_id !== me.data.id ?
                        getTranslations('expression_740') :
                        ''"
                 class="input-group mb-2">
              <select :disabled="tasks.task.admin_id !== tasks.task.user_id && tasks.task.admin_id !== me.data.id"
                      v-model="tasks.task.priority_key"
                      class="input_forms custom-select">
                <option disabled>{{ getTranslations('expression_639') }}</option>
                <option v-for="priority in configs.data.task_priorities"
                        :key="priority.id"
                        :value="priority.id">
                  {{ priority.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2">
        <span @click.prevent="deleteTask"
              v-if="(me.data.role_key > 0 || tasks.task.admin_id === tasks.task.user_id)"
              data-dismiss="modal"
              class="shadow-sm cursor_pointer animated--grow-in btn-outline-danger py-2 px-3 mr-2">
          <span class="">{{ getTranslations('expression_742') }}</span>
        </span>
        <span
          @click.prevent="editTask"
          data-dismiss="modal"
          class="shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
          <span class="">{{ getTranslations('expression_640') }}</span>
        </span>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalEditTaskDiscontinued",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['me', 'tasks', 'configs']),
    ...mapGetters([
      'getUsersArray',
      'getUserObject',
    ])
  },
  methods: {
    editTask(){
      this.tasks.task.me = this.me.data.id
      this.$store.dispatch('updateTask', this.tasks.task)
    },
    deleteTask(){
      this.$swal.fire({
        title: this.getTranslations('expression_899'),
        text: this.getTranslations('expression_311'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.getTranslations('expression_421'),
        cancelButtonText: this.getTranslations('expression_355')
      }).then((result) => {
        if (result.isConfirmed) {
          this.tasks.task.me = this.me.data.id
          this.$store.dispatch('deleteTask', this.tasks.task)
          $('#editTask').modal('hide')
        }
      })
    },

  }
}
</script>

<style scoped>
.form-control:disabled, .form-control[readonly] {
  background-color: #fff;
  cursor: not-allowed;
}
.custom-select:disabled {
  color: #28282d;
  background-color: #fff;
  cursor: not-allowed;
}
</style>
